






import { defineComponent } from '@vue/composition-api';
import { Icon } from '@iconify/vue2';
export default defineComponent({
    name: 'NotificationExceptionEventIcon',
    components: { Icon },
    props: {
        referenceType: {
            type: String,
            required: false,
        },
        eventType: {
            type: String,
            required: true,
        },
        dropdown: {
            type: Boolean,
            default: false,
        },
    },
});
